module.exports = __webpack_public_path__ + "static/media/empty-set.721fbfa8.svg";